/**
 * Extrae líneas legibles para validar un saldo a favor / abono a partir del historial (ledger).
 * Depende de payloads enriquecidos en el backend (ACCESSORIES_OR_LINES_UPDATED.creditBreakdown, DELIVERY_ADJUSTED, etc.).
 */

function parseLedgerPayload(raw) {
  if (raw == null) return null;
  if (typeof raw === 'object') return raw;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return null;
}

/**
 * @param {Array<{ id?: number, createdAt?: string, eventType?: string, payload?: unknown }>} ledgerEntries
 * @returns {Array<{ key: string, description: string, amountEur: number }>}
 */
export function parseLedgerSaldoFavorDetailLines(ledgerEntries) {
  const list = Array.isArray(ledgerEntries) ? ledgerEntries : [];
  const sorted = [...list].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  const lines = [];
  const maxLines = 24;

  for (const e of sorted) {
    if (lines.length >= maxLines) break;
    const p = parseLedgerPayload(e.payload);
    if (!p) continue;

    if (e.eventType === 'ACCESSORIES_OR_LINES_UPDATED' && p.creditBreakdown) {
      const cb = p.creditBreakdown;
      for (const r of cb.removedAccessories || []) {
        const bike = r.bikeLabel != null ? String(r.bikeLabel) : `línea #${r.rentalId}`;
        lines.push({
          key: `e${e.id}-rm-${r.rentalId}-${r.accessoryId}`,
          description: `Quitado: ${r.name} (bicicleta ${bike})`,
          amountEur: Math.round((Number(r.amountEur) || 0) * 100) / 100,
        });
      }
      for (const r of cb.reducedAccessories || []) {
        const bike = r.bikeLabel != null ? String(r.bikeLabel) : `línea #${r.rentalId}`;
        lines.push({
          key: `e${e.id}-red-${r.rentalId}-${r.accessoryId}`,
          description: `Menor importe: ${r.name} (bicicleta ${bike})`,
          amountEur: Math.round((Number(r.amountEur) || 0) * 100) / 100,
        });
      }
    }

    if (e.eventType === 'BOOKING_TOTAL_ADJUSTED') {
      if (p.action === 'DELIVERY_ADJUSTED' && Number(p.deliveryReductionEur) > 0.02) {
        lines.push({
          key: `e${e.id}-delivery`,
          description: 'Suplemento entrega: reducción o eliminación',
          amountEur: Math.round((Number(p.deliveryReductionEur) || 0) * 100) / 100,
        });
      }
      if (p.action === 'SCHEDULE_CHANGED' && p.schedulePriceDelta != null) {
        const dt = Number(p.schedulePriceDelta.deltaTotal);
        if (dt < -0.02) {
          lines.push({
            key: `e${e.id}-sched`,
            description: 'Cambio de fechas (total inferior)',
            amountEur: Math.round(-dt * 100) / 100,
          });
        }
      }
    }
  }

  return lines;
}
